<template>
  <Card class="shipment-visualizer-node">
    <template #content>
      <p class="shipment-identifier">
        {{ t('shipments.shipments') }} {{ shipmentIdentifier }}
      </p>

      <p v-if="renderedMileage" class="text-gray-darker">
        {{ renderedMileage }}
      </p>
    </template>
  </Card>
</template>

<script lang="ts" setup>
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import Card from 'primevue/card';

const props = defineProps({
  shipmentIdentifier: {
    type: Number,
    default: () => -1,
  },
  mileage: {
    type: Number,
    default: () => undefined,
  },
});
const { shipmentIdentifier, mileage } = toRefs(props);

const { t } = useI18n();

const renderedMileage = computed(() => {
  return mileage?.value !== undefined
    ? t('common.paramMilesAbbr', { param: Math.round(mileage.value) })
    : '';
});
</script>

<style>
.shipment-visualizer-node {
  --p-card-body-padding: var(--sp-3);

  .p-card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--sp-1);

    .shipment-identifier {
      font-weight: 500;
    }

    p {
      margin: 0;
    }
  }
}
</style>
